import React, { useState } from "react";

import { SupplementsContextValue } from "./SupplementsContext";
import { FormatedSupplementDoc } from "../../containers/forms/supplements/utils.type";
import { Taker } from "../../containers/forms/supplements/basic-data/basic-data.types";
import { SendTo } from "../../services/SupplementsServices.dto";

export function useSupplementsContext(): SupplementsContextValue {
  const [supplements, setSupplements] = useState<any>([]);
  const [isLife, setIsLife] = React.useState<boolean>(false);
  const [supplementId, setSupplementId] = React.useState<number>(Number.NaN);
  const [supplementChildIds, setSupplementChildIds] = React.useState<number[]>([]);
  const [supplementDocs, setSupplementDocs] = useState<FormatedSupplementDoc[]>([]);
  const [taker, setTaker] = useState<Taker | {}>({});
  const [sendTo, setSendTo] = useState<SendTo>({ backOffice: true, sendaApi: false });
  const [isInsuredInSendaPolicy, setIsInsuredInSendaPolicy] = useState<boolean>(false);

  const ctxValue = React.useMemo(
    () => ({
      supplements,
      isLife,
      supplementId,
      supplementChildIds,
      supplementDocs,
      taker,
      sendTo,
      isInsuredInSendaPolicy,
      setSupplements,
      setIsLife,
      setSupplementId,
      setSupplementChildIds,
      setSupplementDocs,
      setTaker,
      setSendTo,
      setIsInsuredInSendaPolicy,
    }),
    [supplements, isLife, supplementId, supplementChildIds, supplementDocs, taker],
  );

  return ctxValue;
}
